import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/Paginated';
import { PreferredProviderListRow } from 'models/PreferredProviderList';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export const preferredProviderListQueryKeys = {
  base: ['preferredProviderLists'],
  index: (params: Record<string, unknown> = {}) => ['preferredProviderLists', 'index', params],
};

// groupId is comma-separated ids.
type ListParams = { search?: string; groupId?: string } & BaseIndexQueryParams;

export async function indexPreferredProviderLists(params: ListParams, signal: GenericAbortSignal) {
  return http
    .get<Paginated<PreferredProviderListRow>>('preferred_provider_lists', { params, signal })
    .then((res) => res.data);
}

// Saves the location's whole list; the first save creates it. Responds with the location's page row.
export async function updatePreferredProviderList(locationId: string, groupIds: string[]) {
  return http
    .put<PreferredProviderListRow>(`locations/${locationId}/preferred_provider_list`, { groupIds })
    .then((res) => res.data);
}
